export type SymbolType = 'equity' | 'options';
export type OptionCallPut = 'C' | 'P';

// Aria labels for each focusable element - provides semantic meaning for screen readers
export const ARIA_LABELS = {
    instrumentType: 'Instrument type selector',
    underlyingSymbol: 'Underlying symbol input',
    expirationDate: 'Expiration date picker',
    optionCallPut: 'Option type selector',
    strikePrice: 'Strike price input',
} as const;

// Element selectors for internal focus management using aria-label attributes
export const ELEMENT_SELECTORS = {
    instrumentType: '[aria-label="Instrument type selector"]',
    underlyingSymbol: '[aria-label="Underlying symbol input"]',
    expirationDate: '[aria-label="Expiration date picker"]',
    optionCallPut: '[aria-label="Option type selector"]',
    strikePrice: '[aria-label="Strike price input"]',
} as const;
